import script from "./AnswerReviewModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./AnswerReviewModal.vue?vue&type=script&setup=true&lang=ts"

import "./AnswerReviewModal.vue?vue&type=style&index=0&id=4e435c9e&lang=scss&scoped=true"

import exportComponent from "/builds/lightswitch/reflective/reflective-learning-dashboard-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e435c9e"]])

export default __exports__